var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"position":"absolute","left":"0","top":"0","height":"100%","width":"100%"}}),_vm._v(" "),_c('HeaderView',{staticClass:"header"}),_vm._v(" "),_c('HeaderView',{staticClass:"header2",style:({ transform: _vm.showHeader2 ? 'translateY(0)' : 'translateY(-100%)' })})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afc4a74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 